<script>
import Vue from 'vue';
import { RichTextEditorPlugin, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table } from "@syncfusion/ej2-vue-richtexteditor";
Vue.use(RichTextEditorPlugin);

export default {
    name: "IllnessHistoryTriageNotes",

    data() {

        return {
            templates: [],
            templateID: 0,
        };
    },

    props: {

        triage: Object,
    },

    watch: {

        templateID() {
            if(!this.templateID) return;

            const templates = this.templates.filter(temp => temp.tempID == this.templateID);

            if(!templates.length) return;

            this.triage.notes = templates[0].template;
        },
    },

    provide: {

     richtexteditor:[Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table]
    },

    mounted() {

        this.fetchTemplates();
    },

    methods: {

        fetchTemplates() {

            return this.$http.get(`MedicalFile/GetMedicalNotesTemplateNames`).then(response => {
                this.templates = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="flex flex-wrap mt-1">
    <div class="md:w-1/4 sm:w-full p-tiny">
        <label for="grid-template-illness-triage" class="label-control">Template:</label>
        <v-select class="text-xs bg-white" 
            :options="templates" 
            :reduce="temp => temp.tempID" 
            v-model="templateID" 
            label="tempName" 
        />
    </div>
    <div class="w-full p-tiny">
        <ejs-richtexteditor ref="illnessTriageRTE" v-model.trim="triage.notes" :height="300"
         :insertImageSettings="{
                saveFormat: 'Base64'
            }"
         :toolbarSettings="{
              items:['Bold', 'Italic', 'Underline', 'StrikeThrough',
              'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
              'LowerCase', 'UpperCase', 'SuperScript', 'SubScript' , '|',
              'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
              'Outdent', 'Indent', '|',
              'CreateTable', 'CreateLink', 'Image', '|', 
              'ClearFormat', 'Print', 'SourceCode', 'FullScreen', '|',
              'Undo', 'Redo']
          }">
        </ejs-richtexteditor>
    </div>
</div>
</template>
